import { type AskPunttProjectData } from "@mg/schemas/src/christo/askPuntt";
import { Check } from "@phosphor-icons/react";
import { Flex, Text } from "@radix-ui/themes";

interface ProjectReviewStatusBannerProps {
  projectData: AskPunttProjectData;
}

export function ProjectReviewStatusBanner({
  projectData,
}: ProjectReviewStatusBannerProps) {
  const { stages } = projectData;
  const hasActive = stages.some((s) => s.status === "active");
  const hasNeedsReview = stages.some((s) => s.status === "needs_review");
  const allDone = stages.every((s) => s.status === "done");

  if (hasActive) {
    return (
      <div className="rounded-lg border border-puntt-gold-5 bg-puntt-gold-2 px-3 py-2.5">
        <Flex align="center" gap="2">
          <span className="size-2.5 shrink-0 animate-pulse rounded-full bg-puntt-gold-9" />
          <div>
            <Text size="2" weight="medium" className="text-puntt-gold-11">
              AI review in progress
            </Text>
            <Text as="p" size="1" className="mt-0.5 text-puntt-gold-9">
              AskPuntt will update you on which stages can be skipped (no human
              needed) and which need human review before the project can
              progress.
            </Text>
          </div>
        </Flex>
      </div>
    );
  }

  if (hasNeedsReview && !allDone) {
    return (
      <div className="rounded-lg border border-malachite-200 bg-malachite-50 px-3 py-2.5">
        <Flex align="center" gap="2">
          <Check
            size={14}
            weight="bold"
            className="shrink-0 text-malachite-600"
          />
          <Text size="2" weight="medium" className="text-malachite-800">
            Notifications have been sent to reviewers who need to complete their
            review before the project can progress.
          </Text>
        </Flex>
      </div>
    );
  }

  return null;
}
